export default "__VITE_ASSET__CVaLQS$R__"